/* Jaspa revamp behaviour. Vanilla, no dependencies, loaded with defer.
   Everything degrades: with JS off the page still renders, links still work,
   the product form still posts, and the carousel shows its first slide.

   SIZE: the master plan budgeted under 5 KB for the carousel, accordions and
   sticky bar. Those three come to roughly that. The rest of this file is the
   cart drawer and quick add, which the plan lists separately under Phase 3.
   Whole file is about 11 KB raw, near 3 KB over the wire once compressed, and
   it replaces app JavaScript rather than adding to it. Keep it that way: no
   libraries, no polyfills, and check 09_validate_theme.py before pushing. */
(function () {
  'use strict';
  /* jaspa-assets is rendered by every jaspa section, so this file can be
     included several times per page. Identical classic script tags each
     execute, which double-bound every handler (one Quick add click = one
     add per section on the page). Run once. */
  if (window.__jaspaJs) return;
  window.__jaspaJs = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-j-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-j-main]');
    if (!main) return;
    g.querySelectorAll('[data-j-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.full || btn.querySelector('img').src;
        main.srcset = btn.dataset.fullset || '';
        g.querySelectorAll('[data-j-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
        var sticky = document.querySelector('[data-j-sticky] img');
        if (sticky) sticky.src = main.src;
      });
    });
  });

  /* ---------- quantity ---------- */
  document.querySelectorAll('[data-j-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.addEventListener('click', function (e) {
      var step = e.target.closest('[data-j-step]');
      if (!step || !input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(step.dataset.jStep, 10);
      input.value = Math.max(1, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- variant selection ----------
     Radios post natively, so choosing a variant works with JS off. This only
     keeps the displayed price and button in sync. */
  document.querySelectorAll('#jaspa-product-form').forEach(function (form) {
    var radios = form.querySelectorAll('input[name="id"][type="radio"]');
    if (!radios.length) return;
    var priceBox = document.querySelector('[data-j-price] .j-price');
    var atc = form.querySelector('[data-j-atc]');
    form.addEventListener('change', function (e) {
      var r = e.target;
      if (r.name !== 'id' || !r.checked) return;
      if (priceBox) {
        priceBox.innerHTML = r.dataset.compare
          ? r.dataset.price + ' <s>' + r.dataset.compare + '</s>'
          : r.dataset.price;
      }
      if (atc) {
        var out = r.dataset.available !== 'true';
        atc.disabled = out;
        atc.textContent = out ? 'Sold out' : 'Add to cart';
      }
    });
  });

  /* ---------- gift note reveal ---------- */
  document.querySelectorAll('[data-j-giftnote]').forEach(function (wrap) {
    var box = wrap.querySelector('input[type=checkbox]');
    var area = wrap.querySelector('textarea');
    if (!box || !area) return;
    var sync = function () {
      area.hidden = !box.checked;
      /* Unchecked note must not reach the cart as an empty line item property. */
      area.disabled = !box.checked;
    };
    box.addEventListener('change', sync);
    sync();
  });

  /* ---------- sticky add to cart ---------- */
  var sticky = document.querySelector('[data-j-sticky]');
  if (sticky) {
    var anchor = document.querySelector('[data-j-atc-anchor]');
    var onScroll = function () {
      var past = anchor
        ? anchor.getBoundingClientRect().bottom < 0
        : scrollY > 650;
      sticky.classList.toggle('is-on', past);
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var btn = sticky.querySelector('[data-j-sticky-submit]');
    if (btn) btn.addEventListener('click', function () {
      var form = document.getElementById('jaspa-product-form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ---------- promo zone carousel ---------- */
  /* Slides after the first keep their image sources in data-src / data-srcset
     so they do not compete with the first banner for bandwidth (it is the LCP
     image). Swap them in once the page has loaded; autoplay waits for that. */
  function hydrateSlides(zone) {
    zone.querySelectorAll('[data-srcset]').forEach(function (el) {
      el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset');
    });
    zone.querySelectorAll('img[data-src]').forEach(function (el) {
      el.setAttribute('src', el.getAttribute('data-src')); el.removeAttribute('data-src');
    });
  }
  function afterLoad(fn) {
    if (document.readyState === 'complete') fn();
    else addEventListener('load', fn, { once: true });
  }
  document.querySelectorAll('[data-j-pz]').forEach(function (zone) {
    var track = zone.querySelector('[data-j-pz-track]');
    var dots = zone.querySelector('[data-j-pz-dots]');
    var slides = track ? track.children.length : 0;
    if (!track || slides < 2 || zone.classList.contains('j-pz--single')) return;
    var ready = false;
    afterLoad(function () { hydrateSlides(zone); ready = true; restart(); });
    var idx = 0, timer = null;
    var every = (parseInt(zone.dataset.jPzInterval, 10) || 6) * 1000;

    for (var i = 0; i < slides; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to promo ' + (i + 1));
      b.addEventListener('click', (function (n) {
        return function () { go(n, true); };
      })(i));
      dots.appendChild(b);
    }
    function go(n, manual) {
      if (!ready) { hydrateSlides(zone); ready = true; }
      idx = (n + slides) % slides;
      track.style.transform = 'translateX(-' + idx * 100 + '%)';
      [].forEach.call(dots.children, function (d, k) {
        d.setAttribute('aria-current', k === idx ? 'true' : 'false');
      });
      if (manual) restart();
    }
    function restart() {
      clearInterval(timer);
      if (!reduce && ready) timer = setInterval(function () { go(idx + 1); }, every);
    }
    var prev = zone.querySelector('[data-j-pz-prev]');
    var next = zone.querySelector('[data-j-pz-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1, true); });
    if (next) next.addEventListener('click', function () { go(idx + 1, true); });
    zone.addEventListener('mouseenter', function () { clearInterval(timer); });
    zone.addEventListener('mouseleave', restart);
    var sx = null;
    zone.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    zone.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1), true);
      sx = null;
    }, { passive: true });
    go(0);
  });

  /* ---------- show more reviews ---------- */
  document.querySelectorAll('[data-j-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = document.getElementById(btn.dataset.jMore);
      if (!list) return;
      var hidden = list.querySelectorAll('[hidden]');
      var n = parseInt(btn.dataset.jBatch, 10) || 6;
      for (var i = 0; i < Math.min(n, hidden.length); i++) hidden[i].removeAttribute('hidden');
      if (hidden.length <= n) btn.remove();
    });
  });

  /* ---------- quick add ---------- */
  document.querySelectorAll('[data-j-quickadd]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.jQuickadd;
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding';
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('jaspa:cart:added'));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
      }).catch(function () {
        /* Never fail silently: send them to the product page instead. */
        if (btn.dataset.jUrl) location.href = btn.dataset.jUrl;
        else { btn.textContent = label; btn.disabled = false; }
      });
    });
  });

  /* ---------- cart drawer ----------
     Re-renders itself from Liquid via the Section Rendering API, so the markup
     lives only in sections/jaspa-cart-drawer.liquid. With JS off none of this
     binds and cart links go to the normal /cart page. */
  var drawer = document.querySelector('[data-j-cart]');
  if (drawer) {
    var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

    var open = function () {
      if (!drawer.open) drawer.showModal();
    };
    var close = function () {
      if (drawer.open) drawer.close();
    };

    var refresh = function (thenOpen) {
      drawer.classList.add('is-busy');
      return fetch(root() + '?sections=jaspa-cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['jaspa-cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#jaspa-cart-contents');
          var current = drawer.querySelector('#jaspa-cart-contents');
          if (fresh && current) current.replaceWith(fresh);
          if (thenOpen) open();
        })
        .catch(function () { /* leave the old contents in place */ })
        .then(function () { drawer.classList.remove('is-busy'); });
    };

    var change = function (body) {
      drawer.classList.add('is-busy');
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function () { return refresh(false); })
        .catch(function () { drawer.classList.remove('is-busy'); });
    };

    /* Intercept cart links so the drawer replaces the cart page trip. */
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (link && link.hasAttribute('data-j-cart-view')) return; /* View cart goes to the real page */
      if (link && !e.metaKey && !e.ctrlKey && e.button === 0) {
        e.preventDefault(); e.stopImmediatePropagation();
        refresh(true);
      }
    }, true);

    document.addEventListener('jaspa:cart:added', function () { refresh(true); });

    /* Shopify keeps a saved cart's line prices as they were when the items were
       added, and only re-prices when the cart changes. So a cart from before a
       sale shows old prices until something is added. Once per visit, if the
       cart has items, poke it with an empty update (which re-prices it) and
       redraw the drawer; on the cart page, reload so the page matches. */
    try {
      if (drawer.querySelector('.j-cart__item') && !sessionStorage.getItem('jRepriced')) {
        sessionStorage.setItem('jRepriced', '1');
        fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            refresh(false);
            var shown = document.querySelector('[data-j-cart-total]');
            if (shown && location.pathname.indexOf('/cart') === 0 && +shown.getAttribute('data-j-cart-total') !== c.total_price) location.reload();
          })
          .catch(function () {});
      }
    } catch (e) {}

    drawer.addEventListener('click', function (e) {
      /* Clicking the backdrop closes: the dialog itself is the full-height panel. */
      if (e.target === drawer) return close();
      if (e.target.closest('[data-j-cart-close]')) { e.preventDefault(); return close(); }

      var step = e.target.closest('[data-j-cart-step]');
      if (step) {
        var wrap = step.closest('[data-j-cart-qty]');
        var now = parseInt(wrap.querySelector('i').textContent, 10) || 1;
        return change({ id: wrap.dataset.jCartQty,
                        quantity: Math.max(0, now + parseInt(step.dataset.jCartStep, 10)) });
      }
      var rm = e.target.closest('[data-j-cart-remove]');
      if (rm) return change({ id: rm.dataset.jCartRemove, quantity: 0 });
    });

    /* Order note, saved when the shopper leaves the field. */
    drawer.addEventListener('change', function (e) {
      if (!e.target.matches('[data-j-cart-note]')) return;
      fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    });
  }


  /* ---------- vibe tabs (numbered category tabs) ---------- */
  document.querySelectorAll('[data-j-vtabs]').forEach(function (root) {
    var tabs = [...root.querySelectorAll('[data-j-vtab]')];
    var panels = [...root.querySelectorAll('[data-j-vpanel]')];
    if (tabs.length < 2) return;
    var idx = 0, timer = null;
    var every = (parseInt(root.dataset.jVtabsInterval, 10) || 5) * 1000;
    function go(n, manual) {
      idx = (n + tabs.length) % tabs.length;
      tabs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === idx ? 'true' : 'false');
        t.parentElement.classList.toggle('is-on', k === idx);
      });
      panels.forEach(function (p, k) { p.hidden = k !== idx; });
      if (manual) restart();
    }
    function restart() {
      clearInterval(timer);
      if (!reduce) timer = setInterval(function () { go(idx + 1); }, every);
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { go(k, true); });
    });
    root.addEventListener('click', function (e) {
      var p = e.target.closest('[data-j-vpanel]');
      if (p && p.dataset.href && !e.defaultPrevented && !e.metaKey && !e.ctrlKey) { e.preventDefault(); location.href = p.dataset.href; }
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    go(0); restart();
  });

  /* ---------- scroll reveal ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var els = [].filter.call(document.querySelectorAll('[data-j-reveal]'), function (e) {
      return e.getBoundingClientRect().top > innerHeight;
    });
    els.forEach(function (e) { e.classList.add('j-rv'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
    /* Fail-safe: content must never stay invisible. */
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 2500);
  }





})();
